export enum ParsingType {
    HEX = '0x',
    RAW = 'raw',
    ASCII = 'ascii',
    DECIMAL_NUMBER = 'dec',
    ARBITRATION = 'arb',
    BITS = 'bit'
}
